<template>
  <div class="dormitory-container">


    <!-- 头部信息区域 -->
    <div class="header-section">
      <div class="header-center">
        <div class="building-info">
          <div class="building-selector" @click="toggleBuildingDropdown">
            <span class="building-title">{{ currentBuilding.name }} {{ currentBuilding.time }}</span>
            <i class="dropdown-arrow" :class="{ 'rotated': showBuildingDropdown }">▼</i>
          </div>
          <div class="building-dropdown" v-if="showBuildingDropdown">
            <div 
              v-for="building in buildings" 
              :key="building.id"
              class="building-option"
              @click="selectBuilding(building.id)"
            >
              {{ building.name }} {{ building.time }}
            </div>
          </div>
        </div>
      </div>
      
      <div class="header-right">
        <div class="manager-info">
          <div class="manager-label">宿管人员</div>
          <div class="manager-details">
            <div class="manager-avatar"></div>
            <div class="manager-text">
              <div class="manager-name">郭静</div>
              <div class="manager-phone">18899775689</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计卡片区域 -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="stat-icon blue">👥</div>
        <div class="stat-content">
          <div class="stat-number">{{ statisticsData.total_count }}</div>
          <div class="stat-label">总住宿人数</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon green">👤</div>
        <div class="stat-content">
          <div class="stat-number">{{ statisticsData.total_in }}</div>
          <div class="stat-label">当前归寝人数</div>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon red">🏠</div>
        <div class="stat-content">
          <div class="stat-number">{{ statisticsData.total_out }}</div>
          <div class="stat-label">未归寝人数</div>
        </div>
      </div>
    </div>

    <!-- 宿舍统计区域 -->
    <div class="dormitory-stats">
      <div class="stats-title">宿舍统计</div>
      <div class="floor-tabs">
        <div 
          v-for="floor in availableFloors" 
          :key="floor.id"
          class="floor-tab"
          :class="{ active: activeFloor === floor.id }"
          @click="switchFloor(floor.id)"
        >
          {{ floor.name }}
        </div>
      </div>
      <div class="legend">
        <div class="legend-item">
          <div class="legend-color green"></div>
          <span>归寝</span>
        </div>
        <div class="legend-item">
          <div class="legend-color red"></div>
          <span>未归寝</span>
        </div>
        <!-- <div class="debug-toggle">
          <button @click="toggleDebug" class="debug-btn">
            {{ showDebug ? '关闭调试' : '开启调  }}
          </button>
        </div> -->
      </div>
    </div>

    <!-- 平面图显示区 -->
    
    <div class="floor-plan">
      <!-- 加载状 -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载 ..</div>
      </div>
      
      <!-- 楼层图片显示 -->
      <div 
        class="floor-image-container"
        :class="{ 'ire-floor': activeFloor === 'floorIRE' }"
        :style="{ backgroundImage: `url(/images/room/${currentFloorImage})` }"
      >
        
        <!-- 在图片上叠加宿舍信息 -->
        <div class="room-overlays" :class="{ 'ire-floor': activeFloor === 'floorIRE' }">
          <div 
            v-for="room in currentFloorRooms" 
            :key="room.id"
            class="room-overlay"
            :style="getRoomPosition(room)"
          >
            <!-- 调试指示 -->
            <div class="debug-indicator" v-if="showDebug">
              {{ room.number }}: {{ getRoomPosition(room).top }}, {{ getRoomPosition(room).left }}
            </div>
            
            <div class="room-info1" v-if="currentBuilding.id === 'building3'">
              <div class="room-number" style="visibility: hidden;">{{ room.number }}</div>
              <div class="room-occupancy">({{ room.current }}/{{ room.capacity }})</div>
              <div class="room-residents">
                <div 
                  v-for="resident in room.residents" 
                  :key="resident.id"
                  class="resident1"
                  :class="{ returned1: resident.returned, notReturned1: !resident.returned }"
                >
                  <el-tooltip class="tooltipitem" effect="light" :content="resident.department" placement="top-start">
                    <span>{{ resident.name }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="room-info" v-else>
              <div class="room-number" style="visibility: hidden;">{{ room.number }}</div>
              <div class="room-occupancy">({{ room.current }}/{{ room.capacity }})</div>
              <div class="room-residents">
                <div 
                  v-for="resident in room.residents" 
                  :key="resident.id"
                  class="resident"
                  :class="{ returned: resident.returned, notReturned: !resident.returned }"
                >
                  <el-tooltip class="tooltipitem" effect="light" :content="resident.department" placement="top-start">
                    <span>{{ resident.name }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    

    <!-- 底部标题 -->
    <div class="floor-title">
      {{ currentFloorTitle }}
    </div>
  </div>
</template>

<script>
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'VisualDormitory',
  data() {
    return {
      activeTab: '宿舍管理',
      activeFloor: 'floor2',
      floors: [
        { id: 'floor2', name: '二楼', title: '本科楼二层平面图', building: 'building1', image: '本科楼二楼.png', floor: 2 },
        { id: 'floor3', name: '新三楼', title: '本科楼新三层平面图', building: 'building1', image: '本科楼新三楼.png', floor: 'A3' },
        { id: 'floorIRE', name: '老三楼', title: '本科楼IRE层平面图', building: 'building1', image: '本科楼老三楼.png', floor: 'B3' },
        { id: 'floor4', name: '四楼', title: '本科楼四层平面图', building: 'building1', image: '本科楼四楼.png', floor: 4 },
        { id: 'floor2_phd', name: '二楼', title: '硕博楼二层平面图', building: 'building2', image: '硕博楼二楼.png', floor: 2 },
        { id: 'floor3_phd', name: '三楼', title: '硕博楼三层平面图', building: 'building2', image: '硕博楼三楼.png', floor: 3 },
        { id: 'floor2_ly', name: '二楼', title: '蓝领公寓二层平面图', building: 'building3', image: 'lanling2.png', floor: 2 },
        { id: 'floor3_ly', name: '三楼', title: '蓝领公寓三层平面图', building: 'building3', image: 'lanling3.png', floor: 3 }
      ],
      roomsData: {},
      showBuildingDropdown: false,
      buildings: [
        { id: 'building1', name: '本科楼', time: '22:00-06:00' },
        { id: 'building2', name: '硕博楼', time: '22:00-06:00' },
        { id: 'building3', name: '蓝领楼', time: '22:00-06:00' }
      ],
      currentBuilding: { id: 'building1', name: '本科楼', time: '22:00-06:00' },
      showDebug: false, // 新增的调试模式开关
      loading: false,
      // 人数统计数据
      statisticsData: {
        total_count: 0,
        total_in: 0,
        total_out: 0
      }
    };
  },
  computed: {
    currentFloorRooms() {
      const allRooms = this.roomsData[this.activeFloor] || [];
      
      // 根据楼层过滤房间
      if (this.activeFloor === 'floor3') {
        // 新三楼只显示A3开头的房间
        return allRooms.filter(room => room.number && room.number.startsWith('A3'));
      } else if (this.activeFloor === 'floorIRE') {
        // 老三楼只显示B3开头的房间
        return allRooms.filter(room => room.number && room.number.startsWith('B3'));
      }
      
      // 其他楼层显示所有房间
      return allRooms;
    },
    currentFloorTitle() {
      const floor = this.floors.find(f => f.id === this.activeFloor);
      return floor ? floor.title : '';
    },
    availableFloors() {
      return this.floors.filter(f => f.building === this.currentBuilding.id);
    },
    currentFloorImage() {
      const floor = this.floors.find(f => f.id === this.activeFloor);
      return floor ? floor.image : '';
    }
  },
  created() {
    // 确保默认楼层设置正确
    console.log('组件创建，当前楼层:', this.activeFloor);
  },
  async mounted() {
    // 监听点击外部关闭下拉菜单
    document.addEventListener('click', this.handleClickOutside);
    // 初始化加载数据
    console.log('组件挂载，开始加载数据...');
    await this.loadFloorData(); // 加载楼层数据
    await this.loadStatisticsData(); // 加载人数统计数据
    console.log('数据加载完成');
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    switchFloor(floorId) {
      this.activeFloor = floorId;
      this.loadFloorData();
    },
    refreshData() {
      // 刷新数据的方       console.log('刷新数据');
      this.loadFloorData();
    },
    toggleBuildingDropdown() {
      this.showBuildingDropdown = !this.showBuildingDropdown;
    },
    selectBuilding(buildingId) {
      this.currentBuilding = this.buildings.find(b => b.id === buildingId);
      this.showBuildingDropdown = false;
      // 切换宿舍楼时重置到第一个可用楼层
      const availableFloors = this.floors.filter(f => f.building === buildingId);
      if (availableFloors.length > 0) {
        this.activeFloor = availableFloors[0].id;
        this.loadFloorData();
        this.loadStatisticsData(); // 切换楼栋时重新加载统计数据
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showBuildingDropdown = false;
      }
    },
    
    getRoomPosition(room) {
      // 位置配置变量，方便调试和调整
      const config = {
        // 行位置
        topRow: '90px',      // 上排房间位置 
        bottomRow: '410px',  // 下排房间位置
        
        // 列位置间距
        leftSpacing: 109,     // 房间之间的水平间距
        
        // 起始位置
        leftStart: 10,       // 最左侧房间的起始位置
        rightStart: 400,     // 右侧区域的起始位置
        
        // 特殊房间位置
        specialLeft: 670,    // 特殊房间的左侧位置
        specialRight: 740    // 特殊房间的右侧位置
      };
      
      // 根据房间号计算在平面图上的位置
      const positions = {};
      
      if (room.number) {
        // 判断是本科楼还是硕博楼
        const isUndergraduate = this.currentBuilding.name === '本科楼';
        const isGraduate = this.currentBuilding.name === '硕博楼';
        const isLanling = this.currentBuilding.name === '蓝领楼';
        
        if (isUndergraduate) {
          // 本科楼逻辑
          console.log(room.number);
          if (room.number.startsWith('A3')) {
            // 新三 A3xx
            const roomNum = parseInt(room.number.substring(1));
            if (roomNum >= 303 && roomNum <= 312) {
              // 下排房间 A303-A312
              const index = roomNum - 303;
              positions[room.number] = { 
                top: config.bottomRow, 
                left: `${config.leftStart + config.leftSpacing * index}px` 
              };
            } else if (roomNum >= 301 && roomNum <= 302) {
              // 上排左侧房间 A301-A302
              let index = roomNum - 301;
              index = 1 - index;
              positions[room.number] = { 
                top: config.topRow, 
                left: `${config.leftStart + config.leftSpacing * index}px` 
              };
            } else if (roomNum >= 316 && roomNum <= 319) {
              // 上排右侧房间 A316-A319 (倒序显示)
              const index = 319 - roomNum; // 倒序：A319在最左，A316在最右
              positions[room.number] = { 
                top: config.topRow, 
                left: `${config.specialLeft + config.leftSpacing * (index-1) - 5}px` 
              };
            } else if (roomNum === 315) {
              // A315 放到A316的右边
              positions[room.number] = { 
                top: '80px', // 比标准上排位置更高
                left: `${config.specialLeft + config.leftSpacing * 3 - 8}px` // A316右边一个位置
              };
            } else if (roomNum === 314) {
              // A314 放到A315的右边
              positions[room.number] = { 
                top: config.topRow, 
                left: `${config.specialLeft + config.leftSpacing * 4 - 8}px` // A315右边一个位置
              };
            }
          } else if (room.number.startsWith('B3')) {
            // 老三 B3xx - 根据1300px尺寸布局
            const roomNum = parseInt(room.number.substring(1));
            
            // 老三楼布局配置变量
            const ireConfig = {
              // 行位置
              topRow: '110px',      // 上排房间位置 (321-326)
              middleTopRow: '300px', // 中上排房间位置 (315-320)
              middleRow: '203px',    // 中排房间位置 (328-329, 301-304)
              middleBottomRow: '380px', // 中下排房间位置 (314-311逆序)
              bottomRow: '440px',    // 下排房间位置 (308-305逆序)
              
              // 列位置
              leftStart: 3,       // 左侧起始位置
              rightStart: 1043,     // 右侧起始位置
              connectStart: 600,   // 连接区域起始位置
              
              // 房间间隔
              spacing: 80.3        // 房间之间的水平间距
            };
            
            if (roomNum >= 321 && roomNum <= 326) {
              // 上排房间 B321-B326 (从左到右)
              const index = roomNum - 321;
              positions[room.number] = { 
                top: ireConfig.topRow, 
                left: `${ireConfig.leftStart + index * ireConfig.spacing}px` 
              };
            } else if (roomNum >= 315 && roomNum <= 320) {
              // 中上排房间 B320-B315 (从左到右，倒序)
              const index = 320 - roomNum;
              positions[room.number] = { 
                top: ireConfig.middleTopRow, 
                left: `${ireConfig.leftStart + index * ireConfig.spacing}px` 
              };
            } else if (roomNum >= 328 && roomNum <= 329) {
              // 中排左侧房间 B328-B329
              const index = roomNum - 328;
              positions[room.number] = { 
                top: ireConfig.middleRow, 
                left: `${ireConfig.leftStart + (index+8) * ireConfig.spacing}px` 
              };
            } else if (roomNum >= 301 && roomNum <= 304) {
              // 中排右侧房间 B301-B304
              const index = roomNum - 301;
              positions[room.number] = { 
                top: ireConfig.middleRow, 
                left: `${ireConfig.rightStart + index * (ireConfig.spacing+7)}px` 
              };
            } else if (roomNum >= 311 && roomNum <= 314) {
              // 中下排房间 B314-B311 (逆序)
              const index = 314 - roomNum;
              positions[room.number] = { 
                top: ireConfig.middleBottomRow, 
                left: `${ireConfig.leftStart + (index+6) * ireConfig.spacing+2}px` 
              };
            } else if (roomNum >= 305 && roomNum <= 308) {
              // 下排房间 B308-B305 (逆序)
              const index = 308 - roomNum;
              positions[room.number] = { 
                top: ireConfig.bottomRow, 
                left: `${ireConfig.rightStart + index * (ireConfig.spacing+7)}px` 
              };
            }
          } else if (room.number.match(/^[2-9]\d{2}$/)) {
            // 其他楼层 2xx, 3xx, 4xx
            const roomNum = parseInt(room.number);
            const floor = Math.floor(roomNum / 100);
            const roomInFloor = roomNum % 100;
            
            if (floor === 2) {
              // 二楼
              if (roomInFloor >= 16 && roomInFloor <= 18) {
                // 上排特殊房间 216-218
                let index = roomInFloor - 16;
                index = 2 - index;
                positions[room.number] = { 
                  top: config.topRow, 
                  left: `${config.specialLeft + config.leftSpacing * index}px` 
                };
              } else if (roomInFloor >= 3 && roomInFloor <= 12) {
                // 下排房间 203-212
                const index = roomInFloor - 3;
                positions[room.number] = { 
                  top: config.bottomRow, 
                  left: `${config.leftStart + config.leftSpacing * index}px` 
                };
              }
            } else if (floor === 4) {
              // 四楼 - 和新三楼布局一样，房间号对应关系：
              // 新三楼A303->四楼403, A304->404, A305->405, A306->406, A307->407, A308->408, A309->409, A310->410, A311->411, A312->412
              // 新三楼A301->四楼401, A302->402
              // 新三楼A316->四楼416, A317->417, A318->418, A319->419
              // 新三楼A315->四楼415, A314->414
              if (roomInFloor >= 3 && roomInFloor <= 11 && roomInFloor != 5) {
                // 下排房间 403-412 (对应新三楼A303-A312)
                const index = roomInFloor - 3;
                positions[room.number] = { 
                  top: config.bottomRow, 
                  left: `${config.leftStart + config.leftSpacing * index}px` 
                };
              } else if (roomInFloor >= 1 && roomInFloor <= 2) {
                // 上排左侧房间 401-402 (对应新三楼A301-A302) 
                let index = roomInFloor - 1;
                index = 1 - index;
                positions[room.number] = { 
                  top: config.topRow, 
                  left: `${config.leftStart + config.leftSpacing * index}px` 
                };
              } else if (roomInFloor >= 16 && roomInFloor <= 19) {
                // 上排右侧房间 416-419 (对应新三楼A316-A319，参考A319-A316布局)
                if (roomInFloor === 19) {
                  // 419 (对应A319) - 最左侧
                  positions[room.number] = { 
                    top: config.topRow, 
                    left: `${config.specialLeft - config.leftSpacing - 7}px` 
                  };
                } else if (roomInFloor === 18) {
                  // 418 (对应A318) - 第二个位置
                  positions[room.number] = { 
                    top: config.topRow, 
                    left: `${config.specialLeft - 5}px` 
                  };
                } else if (roomInFloor === 17) {
                  // 417 (对应A317) - 第三个位置
                  positions[room.number] = { 
                    top: config.topRow, 
                    left: `${config.specialLeft + config.leftSpacing * 2 - config.leftSpacing - 8}px` 
                  };
                } else if (roomInFloor === 16) {
                  // 416 (对应A316) - 第四个位置
                  positions[room.number] = { 
                    top: config.topRow, 
                    left: `${config.specialLeft + config.leftSpacing * 3 - config.leftSpacing - 8}px` 
                  };
                }
              } else if (roomInFloor === 15) {
                // 415 (对应新三楼A315) 放到416的右边
                positions[room.number] = { 
                  top: '80px', // 比标准上排位置更高
                  left: `${config.specialLeft + config.leftSpacing * 3 - 8}px` // 416右边一个位置
                };
              } else if (roomInFloor === 14) {
                // 414 (对应新三楼A314) 放到415的右边
                positions[room.number] = { 
                  top: config.topRow, 
                  left: `${config.specialLeft + config.leftSpacing * 4 - 8}px` // 415右边一个位置
                };
              } else if (roomInFloor === 12) {
                // 412 特殊位置
                positions[room.number] = { 
                  top: '430px', 
                  left: `${config.specialLeft + config.leftSpacing * 3 - 8}px` 
                };
              } else if (roomInFloor === 13) {
                // 413 特殊位置
                positions[room.number] = { 
                  top: config.bottomRow, 
                  left: `${config.specialLeft + config.leftSpacing * 4 - 8}px` 
                };
              }
            }
          }
        } else if (isGraduate) {
          // 硕博楼逻辑
          if (room.number.match(/^[2-9]\d{2}$/)) {
            const roomNum = parseInt(room.number);
            const floor = Math.floor(roomNum / 100);
            const roomInFloor = roomNum % 100;
            if (floor === 2) {
              // 二楼
              const index = roomInFloor;
              positions[room.number] = { 
                top: '268px', 
                left: `${config.leftStart + 262 + (config.leftSpacing - 14.7) * index}px` 
              };
            } else if (floor === 3) {
              // 三楼
              const index = roomInFloor;
              positions[room.number] = { 
                top: '268px', 
                left: `${config.leftStart + 262 + (config.leftSpacing - 14.7) * index}px` 
              };
            }
          }
        }
        else if(isLanling) {
          if (room.number.match(/^[2-9]\d{2}$/)) {
            const roomNum = parseInt(room.number);
            // const floor = Math.floor(roomNum / 100);
            const roomInFloor = roomNum % 100;
            if(roomInFloor <= 10) {
              positions[room.number] = { 
                top: '280px', 
                left: `${-48 + 53.8 * roomInFloor}px` 
              };
            }
            else {
              positions[room.number] = { 
                top: '280px', 
                left: `${6 + 53.8 * roomInFloor}px` 
              };
            }
          }
        }
      }
        
        return positions[room.number] || { top: '300px', left: '400px' };
      },
    toggleDebug() {
      this.showDebug = !this.showDebug;
    },
    
    // 加载楼层数据
    async loadFloorData() {
      try {
        this.loading = true;
        const currentFloor = this.floors.find(f => f.id === this.activeFloor);
        if (!currentFloor) {
          console.error('未找到当前楼层配置:', this.activeFloor);
          return;
        }
        
        const dormitoryName = this.currentBuilding.name;
        let floor = currentFloor.floor;
        
        console.log('加载楼层数据:', {
          activeFloor: this.activeFloor,
          dormitoryName: dormitoryName,
          floor: floor
        });
        
        // 处理本科楼的新三楼和旧三楼
        if (dormitoryName === '本科楼' && (floor === 'A3' || floor === 'B3')) {
          // 本科楼的新三楼和旧三楼都对应接口的floor=3
          floor = 3;
        }
        
        const url = `${HTTP_CONFIG.SERVER_ADDR}/rooms/?dormitory_name=${encodeURIComponent(dormitoryName)}&floor=${floor}&page_size=50&page=1`;
        console.log('请求URL:', url);
        
        const response = await fetch(url);
        const data = await response.json();
        
        console.log('API响应:', data);
        
        if (data.code === 200 && data.data && data.data.results) {
          // 转换接口数据为组件需要的格式
          const rooms = data.data.results.map(room => ({
            id: room.id,
            number: room.room_number,
            current: room.current_occupancy,
            capacity: room.capacity,
            residents: room.personnel_list.map(person => ({
              id: Math.random(), // 临时ID
              name: person.name.substring(0, 3),
              department: person.name + '：' + person.department,
              returned: person.access_type === 'in'
            }))
          }));
          
          console.log('转换后的房间数据:', rooms);
          
          // 更新房间数据
          this.$set(this.roomsData, this.activeFloor, rooms);
        } else {
          console.warn('API返回数据格式不正确:', data);
        }
      } catch (error) {
        console.error('加载楼层数据失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 加载人数统计数据
    async loadStatisticsData() {
      try {
        const dormitoryName = this.currentBuilding.name;
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personnels/statistics/?dormitory_name=${encodeURIComponent(dormitoryName)}`);
        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.statisticsData = {
            total_count: data.data.total_count || 0,
            total_in: data.data.total_in || 0,
            total_out: data.data.total_out || 0
          };
        }
      } catch (error) {
        console.error('加载人数统计数据失败:', error);
      }
    }
  }
}
</script>

<style scoped>
.dormitory-container {
  background: #f5f5f5;
  min-height: 100vh;
  font-family: 'Microsoft YaHei', sans-serif;
}

/* 功能导航 */
.function-nav {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-tabs {
  display: flex;
  gap: 0;
}

.tab {
  padding: 15px 25px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s;
  font-size: 16px;
  color: #666;
}

.tab.active {
  color: #1890ff;
  border-bottom-color: #1890ff;
  background: #f0f8ff;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  color: #666;
}

.refresh-btn:hover {
  background: #f5f6fa;
}

.refresh-btn img {
  width: 16px;
  height: 16px;
}

.refresh-btn span {
  font-size: 14px;
}

/* 头部信息区域 */
.header-section {
  background: #fff;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}

.header-center .building-info {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}

.building-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.building-selector:hover {
  background: #f5f5f5;
}

.building-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.dropdown-arrow {
  color: #999;
  font-size: 12px;
  transition: transform 0.3s;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.building-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 200px;
}

.building-option {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.3s;
  border-bottom: 1px solid #f0f0f0;
}

.building-option:last-child {
  border-bottom: none;
}

.building-option:hover {
  background: #f5f5f5;
}

.header-right {
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-end;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  font-size: 14px;
}

.calendar-icon {
  font-size: 16px;
}

.manager-info {
  text-align: center;
}

.manager-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.manager-details {
  display: flex;
  align-items: center;
  gap: 10px;
}

.manager-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e0e0e0;
  border: 2px solid #ddd;
}

.manager-text {
  text-align: left;
}

.manager-name {
  font-weight: bold;
  color: #333;
  margin-bottom: 2px;
}

.manager-phone {
  font-size: 12px;
  color: #666;
}

/* 统计卡片区域 */
.stats-section {
  background: #fff;
  padding: 20px;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  min-width: 180px;
}

.stat-icon {
  font-size: 24px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon.blue {
  background: #e3f2fd;
  color: #1976d2;
}

.stat-icon.green {
  background: #e8f5e8;
  color: #388e3c;
}

.stat-icon.red {
  background: #ffebee;
  color: #d32f2f;
}

.stat-content {
  text-align: left;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

/* 宿舍统计区域 */
.dormitory-stats {
  background: #fff;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}

.stats-title {
  font-size: 19px;
  font-weight: bold;
  color: #333;
}

.floor-tabs {
  display: flex;
  gap: 0;
}

.floor-tab {
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  background: #fff;
  transition: all 0.3s;
  font-size: 14px;
  color: #666;
}

.floor-tab:first-child {
  border-radius: 4px 0 0 4px;
}

.floor-tab:last-child {
  border-radius: 0 4px 4px 0;
}

.floor-tab.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.legend {
  display: flex;
  gap: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.legend-color.green {
  background: #52c41a;
}

.legend-color.red {
  background: #ff4d4f;
}

.debug-toggle {
  margin-left: 20px;
}

.debug-btn {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s;
}

.debug-btn:hover {
  background: #f0f0f0;
  border-color: #d0d0d0;
}

.debug-tips {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  color: #856404;
}

.debug-tips h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #856404;
}

.debug-tips p {
  margin: 5px 0;
  font-size: 12px;
  line-height: 1.4;
}

.floor-plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 700px;
  width: 100%;
}

.floor-image-container {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  height: 600px; /* 增加高度以容纳房间信�?*/
  width: 1200px; /* 调整宽度 */
  min-width: 1200px; /* 最小宽�?*/
  max-width: 1200px; /* 最大宽�?*/
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #f8f9fa;
}

/* 老三楼特殊宽�?*/
.floor-image-container.ire-floor {
  width: 1300px;
  min-width: 1300px;
  max-width: 1300px;
}

.common-areas {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 120px;
}

.common-areas.left {
  align-items: flex-start;
}

.common-areas.right {
  align-items: flex-end;
}

.stairs, .facility, .no-entry {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 15px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  min-width: 100px;
}

.stairs-icon, .facility-icon, .no-entry-icon {
  font-size: 20px;
}

.stairs-label, .facility-label, .no-entry-label {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.no-entry {
  background: #fff2f0;
  border-color: #ffccc7;
}

.rooms-section {
  flex: 1;
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: stretch;
}

.room {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  min-width: 80px;
  max-width: 100px;
}

.room-number {
  background: #1890ff;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
}

.room-occupancy {
  font-size: 11px;
  color: #666;
  margin-bottom: 10px;
}

.room-residents {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}

.resident {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.resident1 {
  padding: 2px 4px;
  border-radius: 2px;
  font-size: 11px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.resident.returned {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}
.resident.notReturned {
  background: #fff2f0;
  color: #ff4d4f;
  border: 1px solid #ffccc7;
}
.resident1.returned1 {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}
.resident1.notReturned1 {
  background: #fff2f0;
  color: #ff4d4f;
  border: 1px solid #ffccc7;
}

.room-overlays {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 让点击穿透到图片 */
  transform-origin: top left; /* 设置变换原点 */
}

/* 老三楼时房间叠加信息缩小 */
.room-overlays.ire-floor {
  transform: scale(0.9);
}

.debug-indicator {
  position: absolute;
  top: -25px;
  left: 0;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  white-space: nowrap;
  z-index: 100;
}

.room-overlay {
  position: absolute;
  pointer-events: auto; /* 恢复房间信息的点击事�?*/
  z-index: 10;
  transform: scale(1); /* 确保缩放比例正确 */
  transition: all 0.3s ease; /* 添加平滑过渡效果 */
}

.room-info {
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 10px;
  box-shadow: none;
  min-width: 90px;
  text-align: center;
}
.room-info1 {
  background: transparent;
  border: none;
  border-radius: 4px;
  padding: 5px;
  box-shadow: none;
  min-width: 50px;
  text-align: center;
}

.room-number {
  background: #1890ff;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
  display: inline-block;
}

.room-occupancy {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.room-residents {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.resident {
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  font-weight: 500;
}

/* 底部标题 */
.floor-title {
  background: #fff;
  padding: 15px;
  text-align: center;
  font-size: 16px;
  color: #666;
  border-top: 1px solid #e0e0e0;
}

/* 加载状态样�?*/
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.loading-text {
  font-size: 16px;
  color: #666;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 
